define('commons/sigfox-multi-select',['jquery', 'jquery-multi-select'], function($) {
    // multi-select from Louis Cuny with a "remove option" function
    $.fn.multiSelect.Constructor.prototype.removeOption = function(options){
        var that = this;

        if (options.value) options = [options];
        $.each(options, function(index, option){
            if (option.value && that.$element.find("option[value='"+option.value+"']").length === 1){
                that.$element.find("option[value='" + option.value + "']").remove();
                that.$container.find("ul.ms-list [id^='" + that.sanitize(option.value) + "']").remove();
            }
        });
    };
});
